<template>
  <div v-if="images" class="image">
    <transition-group name="fade" tag="div">
      <div v-for="i in [currentIndex]" :key="i">
        <img :src="currentImg" />
      </div>
    </transition-group>
    <a v-if="images && images.length > 1" class="prev" @click="prev" href="#">
      &#10094; Previous
    </a>
    <a v-if="images && images.length > 1" class="next" @click="next" href="#"
      >Next &#10095;</a
    >
  </div>
</template>
<script>
export default {
  name: "ImageSlider",
  props: ["images"],
  data() {
    return {
      timer: null,
      currentIndex: 0
    };
  },

  methods: {
    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    }
  },

  computed: {
    currentImg: function() {
      if (this.images == undefined) return 0;
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 1.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  max-width: 250px;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  max-width: 250px;
  opacity: 0;
}

img {
  max-width: 250px;
}

.image {
  position: relative;
  height: 170px;
}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 7px;
  width: auto;
  padding: 10px;
  color: white;
  font-size: 18px;
  transition: 0.7s ease;
  text-decoration: none;
  user-select: none;
}

.next {
  right: 0;
}

.prev {
  left: 0;
}

.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.9);
}
</style>
